import React from "react";
// import img from '../marketplaceassets/buildimg.png';
import "./MonitoringVisibility.css";

export default function MonitoringVisibility() {
  return (
    <div id="monitor-visibility" className="outsourcemainclass">
      <div className="left">
        <h2 className="heading">
          Powering Faster Delivery with DevOps Automation
        </h2>
        <p className="subheading">
          At BastionEx, we deliver intelligent DevOps automation services that
          accelerate deployments, streamline workflows, and improve software
          reliability. Our solutions reduce manual effort, enhance
          collaboration, and enable continuous delivery for scalable,
          high-performance operations.
        </p>
        <button>Start monitoring smarter with BastionEx today.</button>
      </div>
      {/* <div className="right">
            <img src={img} alt="error" />
        </div> */}
    </div>
  );
}
